/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Scroll_LeftInputs */

const en_ui_scroll_left = /** @type {(inputs: Ui_Scroll_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scroll left`)
};

/** @type {(inputs: Ui_Scroll_LeftInputs) => LocalizedString} */
const ar_ui_scroll_left = en_ui_scroll_left;

/** @type {(inputs: Ui_Scroll_LeftInputs) => LocalizedString} */
const he_ui_scroll_left = en_ui_scroll_left;

/** @type {(inputs: Ui_Scroll_LeftInputs) => LocalizedString} */
const ur_ui_scroll_left = en_ui_scroll_left;

/** @type {(inputs: Ui_Scroll_LeftInputs) => LocalizedString} */
const es_ui_scroll_left = en_ui_scroll_left;

/** @type {(inputs: Ui_Scroll_LeftInputs) => LocalizedString} */
const fr_ui_scroll_left = en_ui_scroll_left;

/** @type {(inputs: Ui_Scroll_LeftInputs) => LocalizedString} */
const de_ui_scroll_left = en_ui_scroll_left;

/** @type {(inputs: Ui_Scroll_LeftInputs) => LocalizedString} */
const pt_ui_scroll_left = en_ui_scroll_left;

/** @type {(inputs: Ui_Scroll_LeftInputs) => LocalizedString} */
const hi_ui_scroll_left = en_ui_scroll_left;

/** @type {(inputs: Ui_Scroll_LeftInputs) => LocalizedString} */
const bn_ui_scroll_left = en_ui_scroll_left;

/**
* | output |
* | --- |
* | "Scroll left" |
*
* @param {Ui_Scroll_LeftInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const ui_scroll_left = /** @type {((inputs?: Ui_Scroll_LeftInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Scroll_LeftInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_ui_scroll_left(inputs)
	if (locale === "he") return he_ui_scroll_left(inputs)
	if (locale === "ur") return ur_ui_scroll_left(inputs)
	if (locale === "es") return es_ui_scroll_left(inputs)
	if (locale === "fr") return fr_ui_scroll_left(inputs)
	if (locale === "de") return de_ui_scroll_left(inputs)
	if (locale === "pt") return pt_ui_scroll_left(inputs)
	if (locale === "hi") return hi_ui_scroll_left(inputs)
	if (locale === "bn") return bn_ui_scroll_left(inputs)
	return /** @type {LocalizedString} */ ("Scroll left")
});